module.exports = __webpack_public_path__ + "platform/firefox_logo.png";